export var AnnouncementActionType;
(function (AnnouncementActionType) {
    AnnouncementActionType["FETCH_ANNOUNCEMENTS"] = "FETCH_ANNOUNCEMENTS";
    AnnouncementActionType["UPDATE_ANNOUNCEMENT"] = "UPDATE_ANNOUNCEMENT";
})(AnnouncementActionType || (AnnouncementActionType = {}));
export var AnnouncementTypes;
(function (AnnouncementTypes) {
    AnnouncementTypes["BRANDED_SUBDOMAIN"] = "branded_subdomain";
})(AnnouncementTypes || (AnnouncementTypes = {}));
